export const Callback = () => {
    return (
        <div className="content-section">
            You should be redirected away from this page shortly. <br />
            If that does not happen, you will have to use the menu to get (back) to where you want
            to go.
        </div>
    )
}
